"use client";

import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";
import { PanelRight } from "lucide-react";
import { Separator } from "./ui/separator";

type MobileSidebarToggleProps = {
  layoutName: string;
};

export function MobileSidebarToggle({ layoutName }: MobileSidebarToggleProps) {
  const { toggleSidebar, isMobile } = useSidebar();

  if (!isMobile) return null;

  return (
    <>
      <div className="mt-5 flex flex-col">
        <h2 className="px-5 font-display text-xl font-bold leading-6 text-secondary">
          <Button variant="outline" className="mr-4" onClick={toggleSidebar}>
            <PanelRight className="text-secondary" />
            <span className="sr-only">Toggle menu</span>
          </Button>
          {layoutName}
        </h2>
        <Separator className="mt-5" />
      </div>
    </>
  );
}
